import LatestMatchesPage from "./LatestMatchesPage";

export default LatestMatchesPage;
